<template>
  <div>
    <div style="font-size: 14px; color: #606266" class="mb-1">
      <span style="font-size: 14px; color: #606266"
        >Task No：{{ formData.taskNo }}</span
      >
      <el-divider direction="vertical"></el-divider>
      <span>Status：{{ formData.taskStatusName }}</span>
      <el-divider direction="vertical"></el-divider>
      <span>Adjust：{{ formData.adjustFlagName }}</span>
    </div>
    <div style="font-size: 14px; color: #606266" class="mb-2">
      <span style="font-size: 14px; color: #606266">
        Create：{{ formData.createByName }} at
        {{ formData.createDate }}
      </span>
      <el-divider direction="vertical"></el-divider>
      <span style="font-size: 14px; color: #606266">
        Modify：{{ formData.modifyByName }} at
        {{ formData.modifyDate }}
      </span>
      <el-divider direction="vertical"></el-divider>
      <span style="font-size: 14px; color: #606266" v-if="formData.auditByName">
        Reviewed：{{ formData.auditByName }} at
        {{ formData.auditDate }}
      </span>
    </div>
    <el-form ref="formData" :model="formData" :rules="rules" size="small">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_taskRangeFlag') || '任务范围'"
            prop="taskRangeFlag"
          >
            <dict-select
              :disabled="disabled"
              clearable
              filterable
              size="small"
              url="/sys/common/dict/system"
              :body="taskRangeFlagParams"
              v-model="formData.taskRangeFlag"
              :placeholder="
                $l('tips_form_label_taskRangeFlag') || '请选择任务范围'
              "
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item :label="$l('form_label_taskExplain') || '任务说明'">
            <el-input
              :disabled="disabled"
              clearable
              size="small"
              v-model="formData.taskExplain"
              :placeholder="
                $l('tips_form_label_taskExplain') || '请输入任务说明'
              "
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      taskRangeFlagParams: { dictType: 'taskRangeFlag' },
      formData: {},
      rules: {
        taskRangeFlag: [
          {
            required: true,
            message:
              this.$l('tips_form_label_taskRangeFlag') || '请选择任务范围',
            trigger: 'change'
          }
        ]
      }
    }
  },
  watch: {
    data: {
      handler() {
        this.formData = this.data
      },
      immediate: true
    },
    'formData.taskRangeFlag'() {
      const taskRangeFlag = this.formData.taskRangeFlag
      this.$emit('changeTaskRangeFlag', taskRangeFlag)
    }
  },
  mounted() {
    this.$refs.formData.resetFields()
  },
  methods: {
    async getFormData() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) {
        this.$message.error('有必输字段未填写，请检查')
        return
      }
      return this.formData
    },
    async getFlag() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) {
        this.$message.error('有必输字段未填写，请检查')
        return
      }
      let taskRangeFlag = this.formData.taskRangeFlag
      return taskRangeFlag
    }
  }
}
</script>
